/* Soof & Bloom — cart drawer enhancements (shipping protection + recommendations).
   Integrates with Prestige's cart system: bundle sections via cart:prepare-bundled-sections,
   mutate cart with sections param, then dispatch cart:change so <cart-drawer> re-renders itself.

   v2 (2026-05-29): smooth height-collapse + opacity fade when a line item is removed
     (trash click OR qty stepper hits 0). Animation runs BEFORE the cart mutation fires,
     so the user sees the row slide away cleanly before Prestige's replaceChildren rebuilds
     the drawer. Ported from Thomvale's removeLineItemDOM. */
(function () {
  if (window.__sbCart) return;
  window.__sbCart = true;

  // ---------- smooth line-item removal helper ----------
  // height-collapse + opacity fade. Returns a Promise that resolves once the row is gone.
  // Idempotent: if li is missing OR already animating, no-op.
  function smoothRemoveLi(li) {
    if (!li || li.__sbRemoving) return Promise.resolve();
    li.__sbRemoving = true;
    li.style.overflow = 'hidden';
    li.style.transition = 'opacity .18s ease, max-height .28s ease, padding .28s ease, margin .28s ease, border-width .28s ease';
    li.style.maxHeight = li.offsetHeight + 'px';
    return new Promise(function (resolve) {
      var started = false;
      function startCollapse() {
        if (started) return; started = true;
        li.style.opacity = '0';
        li.style.maxHeight = '0';
        li.style.paddingTop = '0';
        li.style.paddingBottom = '0';
        li.style.marginTop = '0';
        li.style.marginBottom = '0';
        li.style.borderWidth = '0';
        setTimeout(function () { try { li.remove(); } catch (e) {} resolve(); }, 290);
      }
      requestAnimationFrame(startCollapse);
      // backup so the chain still resolves if rAF doesn't fire (hidden tab, etc.)
      setTimeout(startCollapse, 50);
    });
  }

  var PROTECT = 47902553080026;          // Shipping protection variant
  var OPTOUT = 'sb_protect_off';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lock = false;
  var recsKey = '';
  var recsHtml = '';

  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    if (sections.indexOf('cart-drawer') === -1) sections.push('cart-drawer');
    return sections;
  }

  async function mutate(endpoint, body, baseEvent) {
    body.sections = bundledSections().join(',');
    body.sections_url = window.location.pathname;
    var res = await fetch(root + 'cart/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json();
    var cart = (data && data.item_count !== undefined) ? data : await (await fetch(root + 'cart.js')).json();
    if (data && data.sections) cart.sections = data.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: baseEvent || 'sb-cart', cart: cart } }));
    return cart;
  }

  function hasProtect(cart) {
    return (cart.items || []).some(function (i) { return i.variant_id === PROTECT; });
  }
  function eligibleCount(cart) {
    return (cart.items || []).reduce(function (n, i) { return n + (i.variant_id === PROTECT ? 0 : i.quantity); }, 0);
  }

  async function removeProtect() {
    var cart = await (await fetch(root + 'cart.js')).json();
    var line = (cart.items || []).filter(function (i) { return i.variant_id === PROTECT; })[0];
    if (!line) return cart;
    return mutate('change.js', { id: line.key, quantity: 0 }, 'sb-protect');
  }

  async function ensureProtect(cart) {
    if (lock) return;
    // no real items left -> don't leave a protection-only cart
    if (eligibleCount(cart) < 1) {
      if (hasProtect(cart)) { lock = true; try { await removeProtect(); } catch (e) {} finally { lock = false; } }
      return;
    }
    if (localStorage.getItem(OPTOUT) === '1') return;
    if (hasProtect(cart)) return;
    lock = true;
    try { await mutate('add.js', { id: PROTECT, quantity: 1 }, 'sb-protect'); }
    catch (e) {}
    finally { lock = false; }
  }

  /* shipping-protection toggle */
  document.addEventListener('change', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sb-protect-toggle]') : null;
    if (!t || lock) return;
    lock = true;
    var p;
    if (t.checked) {
      localStorage.removeItem(OPTOUT);
      p = mutate('add.js', { id: PROTECT, quantity: 1 }, 'sb-protect');
    } else {
      localStorage.setItem(OPTOUT, '1');
      p = removeProtect();
    }
    p.catch(function () {}).finally(function () { lock = false; });
  });

  /* recommendation +Add */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-sb-rec-add]') : null;
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-sb-rec-add');
    var card = add.closest('.sb-rec');
    var sel = card ? card.querySelector('[data-sb-rec-variant]') : null;
    if (sel && sel.value) id = sel.value;
    if (!id) return;
    add.setAttribute('disabled', 'true');
    mutate('add.js', { id: Number(id), quantity: 1 }, 'sb-rec').catch(function () {}).finally(function () { add.removeAttribute('disabled'); });
  });

  /* recommendation slider arrows */
  function recScroll(dir) {
    var list = document.querySelector('[data-sb-recs-list]');
    if (!list) return;
    var card = list.querySelector('.sb-rec');
    var w = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.85;
    list.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sb-recs-prev]')) { e.preventDefault(); recScroll(-1); }
    else if (e.target.closest && e.target.closest('[data-sb-recs-next]')) { e.preventDefault(); recScroll(1); }
  });

  /* remove line item (custom trash icon) — look up the CURRENT line key by variant id,
     since the server-rendered key hash can go stale once a cart discount is applied.
     v2: smooth height-collapse + opacity fade BEFORE the cart mutation fires so the row
     slides away cleanly. Prestige's cart:change replaceChildren happens after — by then
     the line is gone and the new HTML doesn't include it, so the rebuild is a no-flash. */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('[data-sb-remove]') : null;
    if (!rm) return;
    e.preventDefault();
    var vid = Number(rm.getAttribute('data-sb-remove'));
    if (!vid) return;
    var li = rm.closest('.sb-li');
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (!line) return;
      return smoothRemoveLi(li).then(function () {
        return mutate('change.js', { id: line.key, quantity: 0 }, 'sb-remove');
      });
    }).catch(function () {});
  });

  /* quantity stepper (custom, live key lookup — immune to stale rendered keys).
     v2: when the new qty hits 0, animate the row out smoothly before mutating. */
  var qtyBusy = false;
  document.addEventListener('click', function (e) {
    var q = e.target.closest ? e.target.closest('[data-sb-qty]') : null;
    if (!q || qtyBusy) return;
    e.preventDefault();
    var vid = Number(q.getAttribute('data-vid'));
    var dir = q.getAttribute('data-sb-qty') === 'inc' ? 1 : -1;
    if (!vid) return;
    qtyBusy = true;
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (!line) { qtyBusy = false; return; }
      var nq = line.quantity + dir; if (nq < 0) nq = 0;
      if (nq === 0) {
        var li = q.closest('.sb-li');
        return smoothRemoveLi(li).then(function () {
          return mutate('change.js', { id: line.key, quantity: 0 }, 'sb-qty');
        });
      }
      return mutate('change.js', { id: line.key, quantity: nq }, 'sb-qty');
    }).catch(function () {}).finally(function () { qtyBusy = false; });
  });

  async function loadRecs() {
    var wrap = document.querySelector('[data-sb-recs]');
    var list = document.querySelector('[data-sb-recs-list]');
    if (!wrap || !list) return;
    var cart;
    try { cart = await (await fetch(root + 'cart.js')).json(); } catch (e) { return; }
    var items = (cart.items || []).filter(function (i) { return i.variant_id !== PROTECT; });
    if (!items.length) { wrap.hidden = true; return; }
    var key = items.map(function (i) { return i.product_id; }).sort().join(',');
    if (key === recsKey && list.children.length) { wrap.hidden = false; return; }
    // list got emptied (drawer re-render) but cart unchanged -> re-inject cached cards, no refetch
    if (key === recsKey && recsHtml) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
    var pid = items[0].product_id;
    var inCart = {};
    items.forEach(function (i) { inCart[i.product_id] = 1; });
    function fallback() {
      if (recsHtml && key === recsKey) { list.innerHTML = recsHtml; wrap.hidden = false; enableSwipe(list); return; }
      if (list.children.length) { wrap.hidden = false; return; }
      wrap.hidden = true;
    }
    var data;
    try { data = await (await fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')).json(); }
    catch (e) { fallback(); return; }
    var prods = (data.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 6);
    if (!prods.length) { fallback(); return; }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    function money(c) { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    var html = '';
    prods.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var priceHtml;
      if (p.compare_at_price && p.compare_at_price > p.price) {
        priceHtml = '<span class="sb-rec__was">' + money(p.compare_at_price) + '</span> <span class="sb-rec__now">' + money(p.price) + '</span>';
      } else {
        priceHtml = '<span class="sb-rec__now">' + money(p.price) + '</span>';
      }
      var variants = (p.variants || []).filter(function (v) { return v.available; });
      var firstId = variants.length ? variants[0].id : (p.variants && p.variants[0] && p.variants[0].id) || '';
      var sel = '';
      if (variants.length > 1) {
        sel = '<select class="sb-rec__variant" data-sb-rec-variant>';
        variants.forEach(function (v) { sel += '<option value="' + v.id + '">' + (v.title || '') + '</option>'; });
        sel += '</select>';
      }
      html += '<div class="sb-rec">' +
        '<a class="sb-rec__imgwrap" href="' + p.url + '"><img class="sb-rec__img" src="' + img + '" alt="" loading="lazy"></a>' +
        '<div class="sb-rec__body">' +
          '<a class="sb-rec__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="sb-rec__price">' + priceHtml + '</div>' +
          '<div class="sb-rec__actions">' + sel +
            '<button type="button" class="sb-rec__add" data-sb-rec-add="' + firstId + '">+ Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    list.innerHTML = html;
    recsHtml = html;
    recsKey = key;
    wrap.hidden = false;
    enableSwipe(list);
  }

  /* let users swipe/drag between recommendation cards (and stop the drawer
     from hijacking the horizontal gesture as a swipe-to-close) */
  function enableSwipe(list) {
    if (list.__sbSwipe) return;
    list.__sbSwipe = true;
    // stop touch gestures within the whole recs section from reaching the drawer's
    // swipe-to-close GestureArea (which otherwise hijacks the horizontal swipe)
    var section = list.closest('.sb-recs') || list;
    ['touchstart', 'touchmove', 'touchend', 'pointerdown'].forEach(function (ev) {
      section.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
    });
    var down = false, startX = 0, startScroll = 0, moved = false, captured = false, pid = null;
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') {
        down = true; moved = false; captured = false; pid = e.pointerId;
        startX = e.clientX; startScroll = list.scrollLeft;
        // NB: do NOT setPointerCapture on pointerdown -- capturing during a plain click
        // retargets the click to the list and swallows it, breaking +Add, the variant
        // <select> and card links on desktop. Capture lazily, only once a real drag starts.
      }
    });
    list.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        try { list.setPointerCapture(pid); captured = true; } catch (x) {}
      }
      if (moved) list.scrollLeft = startScroll - dx;
    });
    function end() {
      down = false;
      if (captured) { try { list.releasePointerCapture(pid); } catch (x) {} captured = false; }
    }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('pointerleave', end);
    // prevent a drag from triggering the card link / +Add click
    list.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  document.addEventListener('cart:change', function () {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { ensureProtect(c); loadRecs(); }).catch(function () {});
  });
  document.addEventListener('cart-drawer:refreshed', function () { loadRecs(); });

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      if (drawer.hasAttribute('open')) {
        loadRecs();
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(ensureProtect).catch(function () {});
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { ensureProtect(c); }).catch(function () {});
})();
